import React, { Fragment } from 'react'

import Constants from '../../config.js'
import ClickToOpenCardDark from '../../components/ClickToOpenCardDark.js'
import ButtonParam from './ButtonParam.js'


/**
 * Logs section (Electron only) — show the log file path and open the log
 * folder in the OS file explorer.
 *
 * Props:
 *   - logpath: path to the log file
 */
const SectionLogs = ({ logpath }) => {
	if (Constants.IS_WEB_BUILD) return null

	let dev_mode = false
	if (!window.electron || !window.electron.hasShell()) dev_mode = true

	let log_path_folder = ""
	if (logpath) {
		if (logpath.includes("\\")) {
			log_path_folder = logpath.substring(0, logpath.lastIndexOf("\\"))
		} else {
			log_path_folder = logpath.substring(0, logpath.lastIndexOf("/"))
		}
	}

	let logfile_text = ""
	let logfile_onclick = null
	if (!dev_mode) {
		logfile_text = "Ouvrir le dossier des Logs"
		logfile_onclick = () => { window.electron.openFolderInExternalWindow(log_path_folder) }
	} else {
		logfile_text = "mode développement: pas de fichier de log"
		logfile_onclick = () => { alert("dev mode: no log file") }
	}

	return (
		<Fragment>
			<ClickToOpenCardDark title="Logs">
				<center><br />
					<div style={{ margin: "0 auto", textAlign: "center", width: "100%" }}>
						<ButtonParam onClick={logfile_onclick}>
							{logfile_text}
						</ButtonParam>
					</div>
					<br />
					<span style={{ wordBreak: "break-all" }}>
						Log File: {logpath ? logpath : "(dev mode: no cache folder)"}
					</span>
					<br />
				</center>
				<br />
			</ClickToOpenCardDark>
			<br />
		</Fragment>
	)
}

export default SectionLogs
